<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading text="Email Results" class="mt-3">
      <template #right>
        <b-button
          variant="success"
          class="ml-1"
          :to="`/results/${result_id}`"
        >
          <i class="fal fa-arrow-left" />
        </b-button>
      </template>
    </default-heading>

    <div class="my-3">
      <ResultEmailForm :submittingForm="submittingForm" :error="error" @submit="submit" />
    </div>

    <h3 v-if="result">#{{ result.report_number }} - {{ result.sample_type && result.sample_type.name }} - {{ result.test_package }}</h3>
    <b-table-lite
      :items="resultInfoRows"
      striped
      small
      bordered
      thead-class="d-none"
    >
      <template
        slot="label"
        slot-scope="data"
      >
        <span class="font-weight-bold">{{ data.value }}</span>
      </template>
      <template slot="value" slot-scope="data">
        <span>{{ data.value }}</span>
      </template>
    </b-table-lite>

    <div v-if="result && samples">
      <h3>Results</h3>
      <b-card v-if="result.sample_type && result.sample_type.name === 'Septic Soil'">
        <SepticSampleResultTable
          :samples="samples"
        />
      </b-card>

      <b-card v-else-if="result.sample_type && result.sample_type.name === 'Irrigation Suitability'">
        <SarSampleResultTable
          :samples="samples"
        />
      </b-card>

      <b-card>
        <SampleResultTable
          :samples="samples"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import ResultEmailForm from '@/components/results/ResultEmailForm'
import ResultModel from '@/models/result/ResultModel'
import SepticSampleResultTable from '@/components/modus/result/table/SepticSampleResultTable'
import SarSampleResultTable from '@/components/modus/result/table/SarSampleResultTable'
import SampleResultTable from '@/components/modus/result/table/SampleResultTable'
import moment from 'moment'
import SampleCollection from '@/collections/result/SampleCollection'

export default {
  name: 'ResultEmailResults',
  components: {
    DefaultHeading,
    ResultEmailForm,
    SepticSampleResultTable,
    SarSampleResultTable,
    SampleResultTable
  },
  data () {
    return {
      loading: false,
      result_id: this.$route.params.id || null,
      result: null,
      samples: null,
      error: null,
      submittingForm: false
    }
  },
  computed: {
    resultInfoRows () {
      const rows = []

      if (this.result) {
        rows.push(
          {
            label: 'Received At',
            value: (this.result.received_at && moment(this.result.received_at).format('YYYY-MM-DD')) || 'Not Specified'
          },
          {
            label: 'Sample Type',
            value: (this.result.sample_type && this.result.sample_type.name) || 'Not Specified'
          },
          {
            label: 'Grower',
            value: this.result.grower || 'Not Specified'
          },
          {
            label: 'Zone',
            value: this.result.zone || 'Not Specified'
          },
          {
            label: 'Crop Type',
            value: this.result.crop_type || 'Not Specified'
          },
          {
            label: 'Crop Stage',
            value: this.result.crop_stage || 'Not Specified'
          }
        )
      }

      return rows.filter(row => row.value && row.value !== 'Not Specified')
    }
  },
  mounted () {
    this.fetchResult()
  },
  methods: {
    fetchResult () {
      const model = new ResultModel({ id: this.result_id })

      const params = {}
      params.connection = ['sample_type']


      model.fetch({ params }).then(({ response }) => {
        this.result = response.data
        this.fetchSamples()
      })
    },

    async fetchSamples () {
      const samples = new SampleCollection()
      const filter = samples.getFilter()

      filter.filterEquals('result_id', this.result.id)
      filter.connectionAdd('sample_results')

      return samples.fetch().then(() => {
        this.samples = samples
        this.loading = false
      })
    },

    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        const resultModel = new ResultModel({ id: this.result_id })

        await resultModel.emailResults({
          emails: form_data.emails
        })

        this.$bvToast.toast('Results Sent', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/results/' + this.result_id)
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please try again'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
